
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsCorperateMessageRecieptDialog extends Serenity.EntityDialog<PsCorperateMessageRecieptRow, any> {
        protected getFormKey() { return PsCorperateMessageRecieptForm.formKey; }
        protected getIdProperty() { return PsCorperateMessageRecieptRow.idProperty; }
        protected getLocalTextPrefix() { return PsCorperateMessageRecieptRow.localTextPrefix; }
        protected getNameProperty() { return PsCorperateMessageRecieptRow.nameProperty; }
        protected getService() { return PsCorperateMessageRecieptService.baseUrl; }
        protected getDeletePermission() { return PsCorperateMessageRecieptRow.deletePermission; }
        protected getInsertPermission() { return PsCorperateMessageRecieptRow.insertPermission; }
        protected getUpdatePermission() { return PsCorperateMessageRecieptRow.updatePermission; }

        protected form = new PsCorperateMessageRecieptForm(this.idPrefix);
        private  user: string ;

        constructor() {
            super();

        // this.form.TimeFg.changeSelect2(e => {
        //     var setpromotimefg:string = this.form.TimeFg.value;
        //     // var setpromotimefgn = this.setPromoTimeFgn;
        //     if (setpromotimefg == "1") {
        //         Serenity.EditorUtils.setReadOnly(this.form.StartTime, false);
        //         Serenity.EditorUtils.setReadOnly(this.form.EndTime, false);
               
        //     } 
        //     else{

        //         Serenity.EditorUtils.setReadOnly(this.form.StartTime, true);
        //         Serenity.EditorUtils.setReadOnly(this.form.EndTime, true);
        //         this.form.StartTime.value = null
        //         this.form.EndTime.value = null
        //     }
        // });      

    }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            
            if (this.isEditMode) {
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active",
                    hint: "Active [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        Q.confirm(
                           '  ยืนยันการเปิดแสดงประกาศ',
                            () => {
                                this.form.Status.value = "1";
                                this.form.ActiveBy.value = this.user;
                            this.form.Activedate.value = (new Date(Date.now())).toDateString();
                                this.form.Status.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "InActive",
                hint: "ยกเลิก Active",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-times-circle text-red",
                
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการเปิดแสดงประกาศนี้ "
                        ,
                        () => {
                            this.form.Status.value = "0";
                            this.form.ActiveBy.value = this.user;
                            this.form.Activedate.value = (new Date(Date.now())).toDateString();
                            this.form.Status.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if(this.isNew()){
                this.form.StartDate.value = (new Date(Date.now())).toDateString();
            }
            

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
            // console.log('User Id : ' + userId.ShopId);
            this.user = userId.Username;
           
                if (this.entity.Status == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    // this.toolbar.findButton('button-save-cancle').hide();
                    // this.toolbar.findButton('button-save-reject').hide();
                } else {
                    // this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();

                }
            
        }

    }
}